import { Link } from 'react-router-dom';
import { trendingVideos } from '@/mocks/videos';

export default function TrendingSection() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门视频推荐
            </h2>
            <p className="text-sm text-foreground-600">最受欢迎的视频内容，大家都在看</p>
          </div>
          <Link
            to="/category/yingshidaquan"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {trendingVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group block rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - ${video.platform}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                    {video.platform}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-3 text-xs text-background-50/90">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {(video.views / 10000).toFixed(1)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400"></i> {video.rating}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/yingshidaquan"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}